import PrimaryAppBar from "./PrimaryAppBar";
import MainMenu from "./MainMenu";

export default function AppHeader() {
  return (
    <>
      <PrimaryAppBar />
      <MainMenu />
    </>
  );
}
